import { logServerSidePropsError } from '../../components/utilities/log-helper'
import { Region } from '../../config/regions'
import { STATUS_CODE } from '../../data/enums/statusCodes'
import fetchHomepageData from '../../data/query/homepage/fetchHomepageData'
import fetchNYLandingData from '../../data/query/homepage/fetchNYLandingData'
import { RouteRedMetrics } from '../../utils/metrics'

// TODO: currently, this page is not working and also causes the build error due to the usage of server actions which are not supported in /pages routing
const HomepagePreview = data => null

export async function getServerSideProps(context) {
  const redMetrics = new RouteRedMetrics({
    method: 'GET',
    route: 'homepage-contentful-preview'
  }).start()

  try {
    const regionName = context?.req?.headers?.host?.split('.')?.[0]

    if (regionName === Region.NEW_YORK) {
      const NYLandingPageResponse = await fetchNYLandingData(true)

      if (
        NYLandingPageResponse.statusCode !== STATUS_CODE.success &&
        NYLandingPageResponse.statusCode !== STATUS_CODE.notFound
      ) {
        redMetrics.end({
          status: NYLandingPageResponse.statusCode,
          error: 'NY landing page preview error'
        })
        return {
          props: { error: true }
        }
      }

      if (NYLandingPageResponse.statusCode === STATUS_CODE.notFound || !NYLandingPageResponse.data) {
        redMetrics.end({
          status: STATUS_CODE.notFound,
          error: 'NY landing page preview data not found'
        })

        return { notFound: true }
      }

      redMetrics.end({
        status: STATUS_CODE.success
      })

      return {
        props: NYLandingPageResponse.data
      }
    }

    const homepageResponse = await fetchHomepageData(regionName, true)

    if (homepageResponse.statusCode !== STATUS_CODE.success && homepageResponse.statusCode !== STATUS_CODE.notFound) {
      redMetrics.end({
        status: homepageResponse.statusCode,
        error: 'Homepage preview data error'
      })
      return {
        props: { error: true }
      }
    }

    if (homepageResponse.statusCode === STATUS_CODE.notFound || !homepageResponse.data) {
      redMetrics.end({
        status: STATUS_CODE.notFound,
        error: 'Homepage preview data not found'
      })

      return { notFound: true }
    }

    redMetrics.end({
      status: STATUS_CODE.success
    })

    return {
      props: homepageResponse.data
    }
  } catch (error) {
    logServerSidePropsError(error)
    redMetrics.end({
      status: STATUS_CODE.internalServerError,
      error: 'Failed to load homepage preview data'
    })

    return { props: { error: true } }
  }
}

export default HomepagePreview
